import React, { useState } from "react";
import taxGif from "./tax-settings.gif";

export const gifToUse = {
  taxSettings: taxGif,
};

interface DisplayGifProps {
  children: React.ReactNode;
  gif: keyof typeof gifToUse;
  size?: number;
}

const DisplayGif: React.FC<DisplayGifProps> = ({
  children,
  gif,
  size = 300,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [key, setKey] = useState(0);

  // Reset key when hover starts to force gif replay
  const handleMouseEnter = () => {
    setIsHovered(true);
    setKey((prev) => prev + 1);
  };

  return (
    <div
      className="tw-relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      {isHovered && (
        <div className="tw-absolute tw-z-50 tw-bottom-full tw-mb-2">
          <img
            key={key}
            src={gifToUse[gif]}
            alt="Hover preview"
            className="tw-rounded-md tw-shadow-lg"
            style={{ maxWidth: `${size}px` }}
          />
        </div>
      )}
    </div>
  );
};

export default DisplayGif;
